import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type ThemeMode = 'system' | 'light' | 'dark';

type UiState = {
  isSideDrawerOpen: boolean;
  isFabMenuOpen: boolean;
  theme: ThemeMode;
};

const getInitialTheme = (): ThemeMode => {
  const stored = window.localStorage.getItem('theme');
  if (stored === 'light' || stored === 'dark' || stored === 'system') {
    return stored;
  }

  return 'system';
};

const initialState: UiState = {
  isSideDrawerOpen: false,
  isFabMenuOpen: false,
  theme: getInitialTheme()
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openSideDrawer: state => {
      state.isSideDrawerOpen = true;
    },
    closeSideDrawer: state => {
      state.isSideDrawerOpen = false;
    },
    toggleFabMenu: state => {
      state.isFabMenuOpen = !state.isFabMenuOpen;
    },
    closeFabMenu: state => {
      state.isFabMenuOpen = false;
    },
    setTheme: (state, action: PayloadAction<ThemeMode>) => {
      state.theme = action.payload;
      window.localStorage.setItem('theme', action.payload);
    },
    toggleTheme: state => {
      if (state.theme === 'system') {
        state.theme = 'dark';
      } else if (state.theme === 'dark') {
        state.theme = 'light';
      } else {
        state.theme = 'system';
      }

      window.localStorage.setItem('theme', state.theme);
    }
  }
});

export const { openSideDrawer, closeSideDrawer, toggleFabMenu, closeFabMenu, setTheme, toggleTheme } =
  uiSlice.actions;

export default uiSlice.reducer;
